import { FrontEndICodeMapService } from './api/FrontEndICodeMapService'

const ICodeModule = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    /**
     * Get state list
     *
     * @param commit | function
     * @param resolve | function
     * @param reject | function
     * @param param | object
     */
    async getIcodeDetailsList ({ commit }, { resolve, reject, icode }) {
      try {
        const response = await FrontEndICodeMapService.fetchIcodeDetailsList(icode)
        const { success, data } = response.data
        if (success === true) {
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    }
  }
}
export default ICodeModule
